var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
// import { AnyARecord } from 'dns';
import dynamic from 'next/dynamic';
const IconDynamicImports = {
    ArrowUp: dynamic(() => import(
    /* webpackChunkName: "IconArrowUp" */
    /* webpackMode: "lazy" */
    '../Arrow/ArrowUp')),
    ArrowDown: dynamic(() => import(
    /* webpackChunkName: "IconArrowDown" */
    /* webpackMode: "lazy" */
    '../Arrow/ArrowDown')),
    ArrowLeft: dynamic(() => import(
    /* webpackChunkName: "IconArrowLeft" */
    /* webpackMode: "lazy" */
    '../Arrow/ArrowLeft')),
    ArrowRight: dynamic(() => import(
    /* webpackChunkName: "IconArrowRight" */
    /* webpackMode: "lazy" */
    '../Arrow/ArrowRight')),
    ArrowIcon: dynamic(() => import(
    /* webpackChunkName: "IconArrowIcon" */
    /* webpackMode: "lazy" */
    '../Arrow/ArrowIcon')),
    BanFilled: dynamic(() => import(
    /* webpackChunkName: "IconBanFilled" */
    /* webpackMode: "lazy" */
    '../Ban/BanFilled')),
    BanOutlined: dynamic(() => import(
    /* webpackChunkName: "IconBanOutlined" */
    /* webpackMode: "lazy" */
    '../Ban/BanOutlined')),
    BarcodeFilled: dynamic(() => import(
    /* webpackChunkName: "IconBarcodeFilled" */
    /* webpackMode: "lazy" */
    '../Barcode/BarcodeFilled')),
    BarcodeOutlined: dynamic(() => import(
    /* webpackChunkName: "IconBarcodeOutlined" */
    /* webpackMode: "lazy" */
    '../Barcode/BarcodeOutlined')),
    BrowsingHistoryFilled: dynamic(() => import(
    /* webpackChunkName: "IconBrowsingHistoryFilled" */
    /* webpackMode: "lazy" */
    '../BrowsingHistory/BrowsingHistoryFilled')),
    BrowsingHistoryOutlined: dynamic(() => import(
    /* webpackChunkName: "IconBrowsingHistoryOutlined" */
    /* webpackMode: "lazy" */
    '../BrowsingHistory/BrowsingHistoryOutlined')),
    BuildingFilled: dynamic(() => import(
    /* webpackChunkName: "IconBuildingFilled" */
    /* webpackMode: "lazy" */
    '../Building/BuildingFilled')),
    BuildingOutlined: dynamic(() => import(
    /* webpackChunkName: "IconBuildingOutlined" */
    /* webpackMode: "lazy" */
    '../Building/BuildingOutlined')),
    BusFilled: dynamic(() => import(
    /* webpackChunkName: "IconBusFilled" */
    /* webpackMode: "lazy" */
    '../Bus/BusFilled')),
    BusOutlined: dynamic(() => import(
    /* webpackChunkName: "IconBusOutlined" */
    /* webpackMode: "lazy" */
    '../Bus/BusOutlined')),
    CalculatorFilled: dynamic(() => import(
    /* webpackChunkName: "IconCalculatorFilled" */
    /* webpackMode: "lazy" */
    '../Calculator/CalculatorFilled')),
    CalculatorOutlined: dynamic(() => import(
    /* webpackChunkName: "IconCalculatorOutlined" */
    /* webpackMode: "lazy" */
    '../Calculator/CalculatorOutlined')),
    CalendarFilled: dynamic(() => import(
    /* webpackChunkName: "IconCalendarFilled" */
    /* webpackMode: "lazy" */
    '../Calendar/CalendarFilled')),
    CalendarOutlined: dynamic(() => import(
    /* webpackChunkName: "IconCalendarOutlined" */
    /* webpackMode: "lazy" */
    '../Calendar/CalendarOutlined')),
    CallMade: dynamic(() => import(
    /* webpackChunkName: "IconCallMade" */
    /* webpackMode: "lazy" */
    '../Arrow/CallMade')),
    CampaignFilled: dynamic(() => import(
    /* webpackChunkName: "IconCampaignFilled" */
    /* webpackMode: "lazy" */
    '../Campaign/CampaignFilled')),
    CampaignOutlined: dynamic(() => import(
    /* webpackChunkName: "IconCampaignOutlined" */
    /* webpackMode: "lazy" */
    '../Campaign/CampaignOutlined')),
    CarFilled: dynamic(() => import(
    /* webpackChunkName: "IconCarFilled" */
    /* webpackMode: "lazy" */
    '../Car/CarFilled')),
    CarOutlined: dynamic(() => import(
    /* webpackChunkName: "IconCarOutlined" */
    /* webpackMode: "lazy" */
    '../Car/CarOutlined')),
    ChangeOrder: dynamic(() => import(
    /* webpackChunkName: "IconChangeOrder" */
    /* webpackMode: "lazy" */
    '../ChangeOrder/ChangeOrder')),
    ChatFilled: dynamic(() => import(
    /* webpackChunkName: "IconChatFilled" */
    /* webpackMode: "lazy" */
    '../Chat/ChatFilled')),
    ChatOutlined: dynamic(() => import(
    /* webpackChunkName: "IconChatOutlined" */
    /* webpackMode: "lazy" */
    '../Chat/ChatOutlined')),
    ChatBubble: dynamic(() => import(
    /* webpackChunkName: "IconChatBubble" */
    /* webpackMode: "lazy" */
    '../ChatBubble/ChatBubble')),
    Check: dynamic(() => import(
    /* webpackChunkName: "IconCheck" */
    /* webpackMode: "lazy" */
    '../Check/Check')),
    CheckCircleFilled: dynamic(() => import(
    /* webpackChunkName: "IconCheckCircleFilled" */
    /* webpackMode: "lazy" */
    '../Check/CheckCircleFilled')),
    CheckCircleOutlined: dynamic(() => import(
    /* webpackChunkName: "IconCheckCircleOutlined" */
    /* webpackMode: "lazy" */
    '../Check/CheckCircleOutlined')),
    CheckboxOff: dynamic(() => import(
    /* webpackChunkName: "IconCheckboxOff" */
    /* webpackMode: "lazy" */
    '../Checkbox/CheckboxOff')),
    CheckboxOn: dynamic(() => import(
    /* webpackChunkName: "IconCheckboxOn" */
    /* webpackMode: "lazy" */
    '../Checkbox/CheckboxOn')),
    ChevronDownFilled: dynamic(() => import(
    /* webpackChunkName: "IconChevronDownFilled" */
    /* webpackMode: "lazy" */
    '../ChevronDown/ChevronDownFilled')),
    ChevronDownOutlined: dynamic(() => import(
    /* webpackChunkName: "IconChevronDownOutlined" */
    /* webpackMode: "lazy" */
    '../ChevronDown/ChevronDownOutlined')),
    ChevronLeftFilled: dynamic(() => import(
    /* webpackChunkName: "IconChevronLeftFilled" */
    /* webpackMode: "lazy" */
    '../ChevronLeft/ChevronLeftFilled')),
    ChevronLeftOutlined: dynamic(() => import(
    /* webpackChunkName: "IconChevronLeftOutlined" */
    /* webpackMode: "lazy" */
    '../ChevronLeft/ChevronLeftOutlined')),
    ChevronRightFilled: dynamic(() => import(
    /* webpackChunkName: "IconChevronRightFilled" */
    /* webpackMode: "lazy" */
    '../ChevronRight/ChevronRightFilled')),
    ChevronRightOutlined: dynamic(() => import(
    /* webpackChunkName: "IconChevronRightOutlined" */
    /* webpackMode: "lazy" */
    '../ChevronRight/ChevronRightOutlined')),
    ChevronUpFilled: dynamic(() => import(
    /* webpackChunkName: "IconChevronUpFilled" */
    /* webpackMode: "lazy" */
    '../ChevronUp/ChevronUpFilled')),
    ChevronUpOutlined: dynamic(() => import(
    /* webpackChunkName: "IconChevronUpOutlined" */
    /* webpackMode: "lazy" */
    '../ChevronUp/ChevronUpOutlined')),
    ClickCollect: dynamic(() => import(
    /* webpackChunkName: "IconClickCollect" */
    /* webpackMode: "lazy" */
    '../ClickCollect/ClickCollect')),
    CloseAccountFilled: dynamic(() => import(
    /* webpackChunkName: "IconCloseAccountFilled" */
    /* webpackMode: "lazy" */
    '../CloseAccount/CloseAccountFilled')),
    CloseAccountOutlined: dynamic(() => import(
    /* webpackChunkName: "IconCloseAccountOutlined" */
    /* webpackMode: "lazy" */
    '../CloseAccount/CloseAccountOutlined')),
    Close: dynamic(() => import(
    /* webpackChunkName: "IconClose" */
    /* webpackMode: "lazy" */
    '../Close/Close')),
    CloseFilled: dynamic(() => import(
    /* webpackChunkName: "IconCloseFilled" */
    /* webpackMode: "lazy" */
    '../Close/CloseFilled')),
    CloseOutlined: dynamic(() => import(
    /* webpackChunkName: "IconCloseOutlined" */
    /* webpackMode: "lazy" */
    '../Close/CloseOutlined')),
    CloudFilled: dynamic(() => import(
    /* webpackChunkName: "IconCloudFilled" */
    /* webpackMode: "lazy" */
    '../Cloud/CloudFilled')),
    CloudOutlined: dynamic(() => import(
    /* webpackChunkName: "IconCloudOutlined" */
    /* webpackMode: "lazy" */
    '../Cloud/CloudOutlined')),
    CommentFilled: dynamic(() => import(
    /* webpackChunkName: "IconCommentFilled" */
    /* webpackMode: "lazy" */
    '../Comment/CommentFilled')),
    CommentOutlined: dynamic(() => import(
    /* webpackChunkName: "IconCommentOutlined" */
    /* webpackMode: "lazy" */
    '../Comment/CommentOutlined')),
    CompareFilled: dynamic(() => import(
    /* webpackChunkName: "IconCompareFilled" */
    /* webpackMode: "lazy" */
    '../Compare/CompareFilled')),
    CompareOutlined: dynamic(() => import(
    /* webpackChunkName: "IconCompareOutlined" */
    /* webpackMode: "lazy" */
    '../Compare/CompareOutlined')),
    CouponsFilled: dynamic(() => import(
    /* webpackChunkName: "IconCouponsFilled" */
    /* webpackMode: "lazy" */
    '../Coupons/CouponsFilled')),
    CouponsOutlined: dynamic(() => import(
    /* webpackChunkName: "IconCouponsOutlined" */
    /* webpackMode: "lazy" */
    '../Coupons/CouponsOutlined')),
    CreditCardFilled: dynamic(() => import(
    /* webpackChunkName: "IconCreditCardFilled" */
    /* webpackMode: "lazy" */
    '../CreditCard/CreditCardFilled')),
    CreditCardOutlined: dynamic(() => import(
    /* webpackChunkName: "IconCreditCardOutlined" */
    /* webpackMode: "lazy" */
    '../CreditCard/CreditCardOutlined')),
    CurrencyFilled: dynamic(() => import(
    /* webpackChunkName: "IconCurrencyFilled" */
    /* webpackMode: "lazy" */
    '../Currency/CurrencyFilled')),
    CurrencyOutlined: dynamic(() => import(
    /* webpackChunkName: "IconCurrencyOutlined" */
    /* webpackMode: "lazy" */
    '../Currency/CurrencyOutlined')),
    DeleteFilled: dynamic(() => import(
    /* webpackChunkName: "IconDeleteFilled" */
    /* webpackMode: "lazy" */
    '../Delete/DeleteFilled')),
    DeleteOutlined: dynamic(() => import(
    /* webpackChunkName: "IconDeleteOutlined" */
    /* webpackMode: "lazy" */
    '../Delete/DeleteOutlined')),
    DesktopFilled: dynamic(() => import(
    /* webpackChunkName: "IconDesktopFilled" */
    /* webpackMode: "lazy" */
    '../Desktop/DesktopFilled')),
    DesktopOutlined: dynamic(() => import(
    /* webpackChunkName: "IconDesktopOutlined" */
    /* webpackMode: "lazy" */
    '../Desktop/DesktopOutlined')),
    DomesticAreaFilled: dynamic(() => import(
    /* webpackChunkName: "IconDomesticAreaFilled" */
    /* webpackMode: "lazy" */
    '../DomesticArea/DomesticAreaFilled')),
    DomesticAreaOutlined: dynamic(() => import(
    /* webpackChunkName: "IconDomesticAreaOutlined" */
    /* webpackMode: "lazy" */
    '../DomesticArea/DomesticAreaOutlined')),
    HorizontalDots: dynamic(() => import(
    /* webpackChunkName: "IconHorizontalDots" */
    /* webpackMode: "lazy" */
    '../Dots/HorizontalDots')),
    VerticalDots: dynamic(() => import(
    /* webpackChunkName: "IconVerticalDots" */
    /* webpackMode: "lazy" */
    '../Dots/VerticalDots')),
    DownloadFilled: dynamic(() => import(
    /* webpackChunkName: "IconDownloadFilled" */
    /* webpackMode: "lazy" */
    '../Download/DownloadFilled')),
    DownloadOutlined: dynamic(() => import(
    /* webpackChunkName: "IconDownloadOutlined" */
    /* webpackMode: "lazy" */
    '../Download/DownloadOutlined')),
    EditFilled: dynamic(() => import(
    /* webpackChunkName: "IconEditFilled" */
    /* webpackMode: "lazy" */
    '../Edit/EditFilled')),
    EditOutlined: dynamic(() => import(
    /* webpackChunkName: "IconEditOutlined" */
    /* webpackMode: "lazy" */
    '../Edit/EditOutlined')),
    ExternalLink: dynamic(() => import(
    /* webpackChunkName: "IconExternalLink" */
    /* webpackMode: "lazy" */
    '../ExternalLink/ExternalLink')),
    EyeFilled: dynamic(() => import(
    /* webpackChunkName: "IconEyeFilled" */
    /* webpackMode: "lazy" */
    '../Eye/EyeFilled')),
    EyeOutlined: dynamic(() => import(
    /* webpackChunkName: "IconEyeOutlined" */
    /* webpackMode: "lazy" */
    '../Eye/EyeOutlined')),
    EyeBanFilled: dynamic(() => import(
    /* webpackChunkName: "IconEyeBanFilled" */
    /* webpackMode: "lazy" */
    '../EyeBan/EyeBanFilled')),
    EyeBanOutlined: dynamic(() => import(
    /* webpackChunkName: "IconEyeBanOutlined" */
    /* webpackMode: "lazy" */
    '../EyeBan/EyeBanOutlined')),
    FastShippingOutlined: dynamic(() => import(
    /* webpackChunkName: "IconFastShippingOutlined" */
    /* webpackMode: "lazy" */
    '../FastShipping/FastShippingOutlined')),
    FavoriteFilled: dynamic(() => import(
    /* webpackChunkName: "IconFavoriteFilled" */
    /* webpackMode: "lazy" */
    '../Favorite/FavoriteFilled')),
    FavoriteOutlined: dynamic(() => import(
    /* webpackChunkName: "IconFavoriteOutlined" */
    /* webpackMode: "lazy" */
    '../Favorite/FavoriteOutlined')),
    FerryFilled: dynamic(() => import(
    /* webpackChunkName: "IconFerryFilled" */
    /* webpackMode: "lazy" */
    '../Ferry/FerryFilled')),
    FerryOutlined: dynamic(() => import(
    /* webpackChunkName: "IconFerryOutlined" */
    /* webpackMode: "lazy" */
    '../Ferry/FerryOutlined')),
    FilterFilled: dynamic(() => import(
    /* webpackChunkName: "IconFilterFilled" */
    /* webpackMode: "lazy" */
    '../Filter/FilterFilled')),
    FilterOutlined: dynamic(() => import(
    /* webpackChunkName: "IconFilterOutlined" */
    /* webpackMode: "lazy" */
    '../Filter/FilterOutlined')),
    FolderFilled: dynamic(() => import(
    /* webpackChunkName: "IconFolderFilled" */
    /* webpackMode: "lazy" */
    '../Folder/FolderFilled')),
    FolderOutlined: dynamic(() => import(
    /* webpackChunkName: "IconFolderOutlined" */
    /* webpackMode: "lazy" */
    '../Folder/FolderOutlined')),
    GiftFilled: dynamic(() => import(
    /* webpackChunkName: "IconGiftFilled" */
    /* webpackMode: "lazy" */
    '../Gift/GiftFilled')),
    GiftOutlined: dynamic(() => import(
    /* webpackChunkName: "IconGiftOutlined" */
    /* webpackMode: "lazy" */
    '../Gift/GiftOutlined')),
    HelpFilled: dynamic(() => import(
    /* webpackChunkName: "IconHelpFilled" */
    /* webpackMode: "lazy" */
    '../Help/HelpFilled')),
    HelpOutlined: dynamic(() => import(
    /* webpackChunkName: "IconHelpOutlined" */
    /* webpackMode: "lazy" */
    '../Help/HelpOutlined')),
    HomeFilled: dynamic(() => import(
    /* webpackChunkName: "IconHomeFilled" */
    /* webpackMode: "lazy" */
    '../Home/HomeFilled')),
    HomeOutlined: dynamic(() => import(
    /* webpackChunkName: "IconHomeOutlined" */
    /* webpackMode: "lazy" */
    '../Home/HomeOutlined')),
    ImageFilled: dynamic(() => import(
    /* webpackChunkName: "IconImageFilled" */
    /* webpackMode: "lazy" */
    '../Image/ImageFilled')),
    ImageOutlined: dynamic(() => import(
    /* webpackChunkName: "IconImageOutlined" */
    /* webpackMode: "lazy" */
    '../Image/ImageOutlined')),
    InfoFilled: dynamic(() => import(
    /* webpackChunkName: "IconInfoFilled" */
    /* webpackMode: "lazy" */
    '../Info/InfoFilled')),
    InfoOutlined: dynamic(() => import(
    /* webpackChunkName: "IconInfoOutlined" */
    /* webpackMode: "lazy" */
    '../Info/InfoOutlined')),
    KeyboardFilled: dynamic(() => import(
    /* webpackChunkName: "IconKeyboardFilled" */
    /* webpackMode: "lazy" */
    '../Keyboard/KeyboardFilled')),
    KeyboardOutlined: dynamic(() => import(
    /* webpackChunkName: "IconKeyboardOutlined" */
    /* webpackMode: "lazy" */
    '../Keyboard/KeyboardOutlined')),
    LanguageFilled: dynamic(() => import(
    /* webpackChunkName: "IconLanguageFilled" */
    /* webpackMode: "lazy" */
    '../Language/LanguageFilled')),
    LanguageOutlined: dynamic(() => import(
    /* webpackChunkName: "IconLanguageOutlined" */
    /* webpackMode: "lazy" */
    '../Language/LanguageOutlined')),
    LaptopFilled: dynamic(() => import(
    /* webpackChunkName: "IconLaptopFilled" */
    /* webpackMode: "lazy" */
    '../Laptop/LaptopFilled')),
    LaptopOutlined: dynamic(() => import(
    /* webpackChunkName: "IconLaptopOutlined" */
    /* webpackMode: "lazy" */
    '../Laptop/LaptopOutlined')),
    LeafFilled: dynamic(() => import(
    /* webpackChunkName: "IconLeafFilled" */
    /* webpackMode: "lazy" */
    '../Leaf/LeafFilled')),
    LikeFilled: dynamic(() => import(
    /* webpackChunkName: "IconLikeFilled" */
    /* webpackMode: "lazy" */
    '../Like/LikeFilled')),
    LikeOutlined: dynamic(() => import(
    /* webpackChunkName: "IconLikeOutlined" */
    /* webpackMode: "lazy" */
    '../Like/LikeOutlined')),
    ListFilled: dynamic(() => import(
    /* webpackChunkName: "IconListFilled" */
    /* webpackMode: "lazy" */
    '../List/ListFilled')),
    ListOutlined: dynamic(() => import(
    /* webpackChunkName: "IconListOutlined" */
    /* webpackMode: "lazy" */
    '../List/ListOutlined')),
    Load: dynamic(() => import(
    /* webpackChunkName: "IconLoad" */
    /* webpackMode: "lazy" */
    '../Load/Load')),
    LocationFilled: dynamic(() => import(
    /* webpackChunkName: "IconLocationFilled" */
    /* webpackMode: "lazy" */
    '../Location/LocationFilled')),
    LocationOutlined: dynamic(() => import(
    /* webpackChunkName: "IconLocationOutlined" */
    /* webpackMode: "lazy" */
    '../Location/LocationOutlined')),
    Login: dynamic(() => import(
    /* webpackChunkName: "IconLogin" */
    /* webpackMode: "lazy" */
    '../Login/Login')),
    Logout: dynamic(() => import(
    /* webpackChunkName: "IconLogout" */
    /* webpackMode: "lazy" */
    '../Logout/Logout')),
    LuckyKujiFilled: dynamic(() => import(
    /* webpackChunkName: "IconLuckyKujiFilled" */
    /* webpackMode: "lazy" */
    '../LuckyKuji/LuckyKujiFilled')),
    LuckyKujiOutlined: dynamic(() => import(
    /* webpackChunkName: "IconLuckyKujiOutlined" */
    /* webpackMode: "lazy" */
    '../LuckyKuji/LuckyKujiOutlined')),
    MailFilled: dynamic(() => import(
    /* webpackChunkName: "IconMailFilled" */
    /* webpackMode: "lazy" */
    '../Mail/MailFilled')),
    MailOutlined: dynamic(() => import(
    /* webpackChunkName: "IconMailOutlined" */
    /* webpackMode: "lazy" */
    '../Mail/MailOutlined')),
    MapFilled: dynamic(() => import(
    /* webpackChunkName: "IconMapFilled" */
    /* webpackMode: "lazy" */
    '../Map/MapFilled')),
    MapOutlined: dynamic(() => import(
    /* webpackChunkName: "IconMapOutlined" */
    /* webpackMode: "lazy" */
    '../Map/MapOutlined')),
    Menu: dynamic(() => import(
    /* webpackChunkName: "IconMenu" */
    /* webpackMode: "lazy" */
    '../Menu/Menu')),
    Minus: dynamic(() => import(
    /* webpackChunkName: "IconMinus" */
    /* webpackMode: "lazy" */
    '../Minus/Minus')),
    MobileFilled: dynamic(() => import(
    /* webpackChunkName: "IconMobileFilled" */
    /* webpackMode: "lazy" */
    '../Mobile/MobileFilled')),
    MobileOutlined: dynamic(() => import(
    /* webpackChunkName: "IconMobileOutlined" */
    /* webpackMode: "lazy" */
    '../Mobile/MobileOutlined')),
    MovieFilled: dynamic(() => import(
    /* webpackChunkName: "IconMovieFilled" */
    /* webpackMode: "lazy" */
    '../Movie/MovieFilled')),
    MovieOutlined: dynamic(() => import(
    /* webpackChunkName: "IconMovieOutlined" */
    /* webpackMode: "lazy" */
    '../Movie/MovieOutlined')),
    MyPageFilled: dynamic(() => import(
    /* webpackChunkName: "IconMyPageFilled" */
    /* webpackMode: "lazy" */
    '../MyPage/MyPageFilled')),
    MyPageOutlined: dynamic(() => import(
    /* webpackChunkName: "IconMyPageOutlined" */
    /* webpackMode: "lazy" */
    '../MyPage/MyPageOutlined')),
    NewsFilled: dynamic(() => import(
    /* webpackChunkName: "IconNewsFilled" */
    /* webpackMode: "lazy" */
    '../News/NewsFilled')),
    NewsOutlined: dynamic(() => import(
    /* webpackChunkName: "IconNewsOutlined" */
    /* webpackMode: "lazy" */
    '../News/NewsOutlined')),
    NewUser: dynamic(() => import(
    /* webpackChunkName: "IconNewUser" */
    /* webpackMode: "lazy" */
    '../NewUser/NewUser')),
    NewWindowFilled: dynamic(() => import(
    /* webpackChunkName: "IconNewWindowFilled" */
    /* webpackMode: "lazy" */
    '../NewWindow/NewWindowFilled')),
    NewWindowOutlined: dynamic(() => import(
    /* webpackChunkName: "IconNewWindowOutlined" */
    /* webpackMode: "lazy" */
    '../NewWindow/NewWindowOutlined')),
    NoticeGenericFilled: dynamic(() => import(
    /* webpackChunkName: "IconNoticeGenericFilled" */
    /* webpackMode: "lazy" */
    '../NoticeGeneric/NoticeGenericFilled')),
    NoticeGenericOutlined: dynamic(() => import(
    /* webpackChunkName: "IconNoticeGenericOutlined" */
    /* webpackMode: "lazy" */
    '../NoticeGeneric/NoticeGenericOutlined')),
    NoticeUserFilled: dynamic(() => import(
    /* webpackChunkName: "IconNoticeUserFilled" */
    /* webpackMode: "lazy" */
    '../NoticeUser/NoticeUserFilled')),
    NoticeUserOutlined: dynamic(() => import(
    /* webpackChunkName: "IconNoticeUserOutlined" */
    /* webpackMode: "lazy" */
    '../NoticeUser/NoticeUserOutlined')),
    PaintFilled: dynamic(() => import(
    /* webpackChunkName: "IconPaintFilled" */
    /* webpackMode: "lazy" */
    '../Paint/PaintFilled')),
    PaintOutlined: dynamic(() => import(
    /* webpackChunkName: "IconPaintOutlined" */
    /* webpackMode: "lazy" */
    '../Paint/PaintOutlined')),
    PDFFilled: dynamic(() => import(
    /* webpackChunkName: "IconPDFFilled" */
    /* webpackMode: "lazy" */
    '../PDF/PDFFilled')),
    PDFOutlined: dynamic(() => import(
    /* webpackChunkName: "IconPDFOutlined" */
    /* webpackMode: "lazy" */
    '../PDF/PDFOutlined')),
    PhoneFilled: dynamic(() => import(
    /* webpackChunkName: "IconPhoneFilled" */
    /* webpackMode: "lazy" */
    '../Phone/PhoneFilled')),
    PhoneOutlined: dynamic(() => import(
    /* webpackChunkName: "IconPhoneOutlined" */
    /* webpackMode: "lazy" */
    '../Phone/PhoneOutlined')),
    PhotographFilled: dynamic(() => import(
    /* webpackChunkName: "IconPhotographFilled" */
    /* webpackMode: "lazy" */
    '../Photograph/PhotographFilled')),
    PhotographOutlined: dynamic(() => import(
    /* webpackChunkName: "IconPhotographOutlined" */
    /* webpackMode: "lazy" */
    '../Photograph/PhotographOutlined')),
    PinFilled: dynamic(() => import(
    /* webpackChunkName: "IconPinFilled" */
    /* webpackMode: "lazy" */
    '../Pin/PinFilled')),
    PinOutlined: dynamic(() => import(
    /* webpackChunkName: "IconPinOutlined" */
    /* webpackMode: "lazy" */
    '../Pin/PinOutlined')),
    PlaneFilled: dynamic(() => import(
    /* webpackChunkName: "IconPlaneFilled" */
    /* webpackMode: "lazy" */
    '../Plane/PlaneFilled')),
    PlaneOutlined: dynamic(() => import(
    /* webpackChunkName: "IconPlaneOutlined" */
    /* webpackMode: "lazy" */
    '../Plane/PlaneOutlined')),
    Plus: dynamic(() => import(
    /* webpackChunkName: "IconPlus" */
    /* webpackMode: "lazy" */
    '../Plus/Plus')),
    PlusFilled: dynamic(() => import(
    /* webpackChunkName: "IconPlusFilled" */
    /* webpackMode: "lazy" */
    '../Plus/PlusFilled')),
    PlusOutlined: dynamic(() => import(
    /* webpackChunkName: "IconPlusOutlined" */
    /* webpackMode: "lazy" */
    '../Plus/PlusOutlined')),
    PointFilled: dynamic(() => import(
    /* webpackChunkName: "IconPointFilled" */
    /* webpackMode: "lazy" */
    '../Point/PointFilled')),
    PointOutlined: dynamic(() => import(
    /* webpackChunkName: "IconPointOutlined" */
    /* webpackMode: "lazy" */
    '../Point/PointOutlined')),
    PriceYenFilled: dynamic(() => import(
    /* webpackChunkName: "IconPriceYenFilled" */
    /* webpackMode: "lazy" */
    '../PriceYen/PriceYenFilled')),
    PriceYenOutlined: dynamic(() => import(
    /* webpackChunkName: "IconPriceYenOutlined" */
    /* webpackMode: "lazy" */
    '../PriceYen/PriceYenOutlined')),
    PrintFilled: dynamic(() => import(
    /* webpackChunkName: "IconPrintFilled" */
    /* webpackMode: "lazy" */
    '../Print/PrintFilled')),
    PrintOutlined: dynamic(() => import(
    /* webpackChunkName: "IconPrintOutlined" */
    /* webpackMode: "lazy" */
    '../Print/PrintOutlined')),
    PurchaseHistoryFilled: dynamic(() => import(
    /* webpackChunkName: "IconPurchaseHistoryFilled" */
    /* webpackMode: "lazy" */
    '../PurchaseHistory/PurchaseHistoryFilled')),
    PurchaseHistoryOutlined: dynamic(() => import(
    /* webpackChunkName: "IconPurchaseHistoryOutlined" */
    /* webpackMode: "lazy" */
    '../PurchaseHistory/PurchaseHistoryOutlined')),
    PushNotificationFilled: dynamic(() => import(
    /* webpackChunkName: "IconPushNotificationFilled" */
    /* webpackMode: "lazy" */
    '../PushNotification/PushNotificationFilled')),
    PushNotificationOutlined: dynamic(() => import(
    /* webpackChunkName: "IconPushNotificationOutlined" */
    /* webpackMode: "lazy" */
    '../PushNotification/PushNotificationOutlined')),
    QRCodeFilled: dynamic(() => import(
    /* webpackChunkName: "IconQRCodeFilled" */
    /* webpackMode: "lazy" */
    '../QRCode/QRCodeFilled')),
    QRCodeOutlined: dynamic(() => import(
    /* webpackChunkName: "IconQRCodeOutlined" */
    /* webpackMode: "lazy" */
    '../QRCode/QRCodeOutlined')),
    RadioButtonOn: dynamic(() => import(
    /* webpackChunkName: "IconRadioButtonOn" */
    /* webpackMode: "lazy" */
    '../RadioButton/RadioButtonOn')),
    RadioButtonOff: dynamic(() => import(
    /* webpackChunkName: "IconRadioButtonOff" */
    /* webpackMode: "lazy" */
    '../RadioButton/RadioButtonOff')),
    RakutenSymbol: dynamic(() => import(
    /* webpackChunkName: "IconRakutenSymbol" */
    /* webpackMode: "lazy" */
    '../RakutenSymbol/RakutenSymbol')),
    RankingFilled: dynamic(() => import(
    /* webpackChunkName: "IconRankingFilled" */
    /* webpackMode: "lazy" */
    '../Ranking/RankingFilled')),
    RankingOutlined: dynamic(() => import(
    /* webpackChunkName: "IconRankingOutlined" */
    /* webpackMode: "lazy" */
    '../Ranking/RankingOutlined')),
    RatingFilled: dynamic(() => import(
    /* webpackChunkName: "IconRatingFilled" */
    /* webpackMode: "lazy" */
    '../Rating/RatingFilled')),
    RatingOutlined: dynamic(() => import(
    /* webpackChunkName: "IconRatingOutlined" */
    /* webpackMode: "lazy" */
    '../Rating/RatingOutlined')),
    Refresh: dynamic(() => import(
    /* webpackChunkName: "IconRefresh" */
    /* webpackMode: "lazy" */
    '../Refresh/Refresh')),
    RegisterAccountFilled: dynamic(() => import(
    /* webpackChunkName: "IconRegisterAccountFilled" */
    /* webpackMode: "lazy" */
    '../RegisterAccount/RegisterAccountFilled')),
    RegisterAccountOutlined: dynamic(() => import(
    /* webpackChunkName: "IconRegisterAccountOutlined" */
    /* webpackMode: "lazy" */
    '../RegisterAccount/RegisterAccountOutlined')),
    RewardsFilled: dynamic(() => import(
    /* webpackChunkName: "IconRewardsFilled" */
    /* webpackMode: "lazy" */
    '../Rewards/RewardsFilled')),
    RewardsOutlined: dynamic(() => import(
    /* webpackChunkName: "IconRewardsOutlined" */
    /* webpackMode: "lazy" */
    '../Rewards/RewardsOutlined')),
    RSSFilled: dynamic(() => import(
    /* webpackChunkName: "IconRSSFilled" */
    /* webpackMode: "lazy" */
    '../RSS/RSSFilled')),
    RSSOutlined: dynamic(() => import(
    /* webpackChunkName: "IconRSSOutlined" */
    /* webpackMode: "lazy" */
    '../RSS/RSSOutlined')),
    RSSSymbol: dynamic(() => import(
    /* webpackChunkName: "IconRSSSymbol" */
    /* webpackMode: "lazy" */
    '../RSS/RSSSymbol')),
    SaveFilled: dynamic(() => import(
    /* webpackChunkName: "IconSaveFilled" */
    /* webpackMode: "lazy" */
    '../Save/SaveFilled')),
    SaveOutlined: dynamic(() => import(
    /* webpackChunkName: "IconSaveOutlined" */
    /* webpackMode: "lazy" */
    '../Save/SaveOutlined')),
    Search: dynamic(() => import(
    /* webpackChunkName: "IconSearch" */
    /* webpackMode: "lazy" */
    '../Search/Search')),
    SearchHistoryFilled: dynamic(() => import(
    /* webpackChunkName: "IconSearchHistoryFilled" */
    /* webpackMode: "lazy" */
    '../SearchHistory/SearchHistoryFilled')),
    SearchHistoryOutlined: dynamic(() => import(
    /* webpackChunkName: "IconSearchHistoryOutlined" */
    /* webpackMode: "lazy" */
    '../SearchHistory/SearchHistoryOutlined')),
    SecurityFilled: dynamic(() => import(
    /* webpackChunkName: "IconSecurityFilled" */
    /* webpackMode: "lazy" */
    '../Security/SecurityFilled')),
    SecurityOutlined: dynamic(() => import(
    /* webpackChunkName: "IconSecurityOutlined" */
    /* webpackMode: "lazy" */
    '../Security/SecurityOutlined')),
    SettingsFilled: dynamic(() => import(
    /* webpackChunkName: "IconSettingsFilled" */
    /* webpackMode: "lazy" */
    '../Settings/SettingsFilled')),
    SettingsOutlined: dynamic(() => import(
    /* webpackChunkName: "IconSettingsOutlined" */
    /* webpackMode: "lazy" */
    '../Settings/SettingsOutlined')),
    ShareFilled: dynamic(() => import(
    /* webpackChunkName: "IconShareFilled" */
    /* webpackMode: "lazy" */
    '../Share/ShareFilled')),
    ShareOutlined: dynamic(() => import(
    /* webpackChunkName: "IconShareOutlined" */
    /* webpackMode: "lazy" */
    '../Share/ShareOutlined')),
    ShippingFilled: dynamic(() => import(
    /* webpackChunkName: "IconShippingFilled" */
    /* webpackMode: "lazy" */
    '../Shipping/ShippingFilled')),
    ShippingOutlined: dynamic(() => import(
    /* webpackChunkName: "IconShippingOutlined" */
    /* webpackMode: "lazy" */
    '../Shipping/ShippingOutlined')),
    ShopFilled: dynamic(() => import(
    /* webpackChunkName: "IconShopFilled" */
    /* webpackMode: "lazy" */
    '../Shop/ShopFilled')),
    ShopOutlined: dynamic(() => import(
    /* webpackChunkName: "IconShopOutlined" */
    /* webpackMode: "lazy" */
    '../Shop/ShopOutlined')),
    ShoppingCartFilled: dynamic(() => import(
    /* webpackChunkName: "IconShoppingCartFilled" */
    /* webpackMode: "lazy" */
    '../ShoppingCart/ShoppingCartFilled')),
    ShoppingCartOutlined: dynamic(() => import(
    /* webpackChunkName: "IconShoppingCartOutlined" */
    /* webpackMode: "lazy" */
    '../ShoppingCart/ShoppingCartOutlined')),
    SliderFilled: dynamic(() => import(
    /* webpackChunkName: "IconSliderFilled" */
    /* webpackMode: "lazy" */
    '../Slider/SliderFilled')),
    SliderOutlined: dynamic(() => import(
    /* webpackChunkName: "IconSliderOutlined" */
    /* webpackMode: "lazy" */
    '../Slider/SliderOutlined')),
    SmartphoneFilled: dynamic(() => import(
    /* webpackChunkName: "IconSmartphoneFilled" */
    /* webpackMode: "lazy" */
    '../Smartphone/SmartphoneFilled')),
    SmartphoneOutlined: dynamic(() => import(
    /* webpackChunkName: "IconSmartphoneOutlined" */
    /* webpackMode: "lazy" */
    '../Smartphone/SmartphoneOutlined')),
    SurveyFilled: dynamic(() => import(
    /* webpackChunkName: "IconSurveyFilled" */
    /* webpackMode: "lazy" */
    '../Survey/SurveyFilled')),
    SurveyOutlined: dynamic(() => import(
    /* webpackChunkName: "IconSurveyOutlined" */
    /* webpackMode: "lazy" */
    '../Survey/SurveyOutlined')),
    SustainabilityFilled: dynamic(() => import(
    /* webpackChunkName: "IconSustainabilityFilled" */
    /* webpackMode: "lazy" */
    '../Sustainability/SustainabilityFilled')),
    SustainabilityOutlined: dynamic(() => import(
    /* webpackChunkName: "IconSustainabilityOutlined" */
    /* webpackMode: "lazy" */
    '../Sustainability/SustainabilityOutlined')),
    TabletFilled: dynamic(() => import(
    /* webpackChunkName: "IconTabletFilled" */
    /* webpackMode: "lazy" */
    '../Tablet/TabletFilled')),
    TabletOutlined: dynamic(() => import(
    /* webpackChunkName: "IconTabletOutlined" */
    /* webpackMode: "lazy" */
    '../Tablet/TabletOutlined')),
    TagFilled: dynamic(() => import(
    /* webpackChunkName: "IconTagFilled" */
    /* webpackMode: "lazy" */
    '../Tag/TagFilled')),
    TagOutlined: dynamic(() => import(
    /* webpackChunkName: "IconTagOutlined" */
    /* webpackMode: "lazy" */
    '../Tag/TagOutlined')),
    TimeFilled: dynamic(() => import(
    /* webpackChunkName: "IconTimeFilled" */
    /* webpackMode: "lazy" */
    '../Time/TimeFilled')),
    TimeOutlined: dynamic(() => import(
    /* webpackChunkName: "IconTimeOutlined" */
    /* webpackMode: "lazy" */
    '../Time/TimeOutlined')),
    TrainFilled: dynamic(() => import(
    /* webpackChunkName: "IconTrainFilled" */
    /* webpackMode: "lazy" */
    '../Train/TrainFilled')),
    TrainOutlined: dynamic(() => import(
    /* webpackChunkName: "IconTrainOutlined" */
    /* webpackMode: "lazy" */
    '../Train/TrainOutlined')),
    UploadFilled: dynamic(() => import(
    /* webpackChunkName: "IconUploadFilled" */
    /* webpackMode: "lazy" */
    '../Upload/UploadFilled')),
    UploadOutlined: dynamic(() => import(
    /* webpackChunkName: "IconUploadOutlined" */
    /* webpackMode: "lazy" */
    '../Upload/UploadOutlined')),
    UserFilled: dynamic(() => import(
    /* webpackChunkName: "IconUserFilled" */
    /* webpackMode: "lazy" */
    '../User/UserFilled')),
    UserOutlined: dynamic(() => import(
    /* webpackChunkName: "IconUserOutlined" */
    /* webpackMode: "lazy" */
    '../User/UserOutlined')),
    VoiceInputFilled: dynamic(() => import(
    /* webpackChunkName: "IconVoiceInputFilled" */
    /* webpackMode: "lazy" */
    '../VoiceInput/VoiceInputFilled')),
    VoiceInputOutlined: dynamic(() => import(
    /* webpackChunkName: "IconVoiceInputOutlined" */
    /* webpackMode: "lazy" */
    '../VoiceInput/VoiceInputOutlined')),
    Walking: dynamic(() => import(
    /* webpackChunkName: "IconWalking" */
    /* webpackMode: "lazy" */
    '../Walking/Walking')),
    WarningFilled: dynamic(() => import(
    /* webpackChunkName: "IconWarningFilled" */
    /* webpackMode: "lazy" */
    '../Warning/WarningFilled')),
    WarningOutlined: dynamic(() => import(
    /* webpackChunkName: "IconWarningOutlined" */
    /* webpackMode: "lazy" */
    '../Warning/WarningOutlined')),
    WorldFilled: dynamic(() => import(
    /* webpackChunkName: "IconWorldFilled" */
    /* webpackMode: "lazy" */
    '../World/WorldFilled')),
    WorldOutlined: dynamic(() => import(
    /* webpackChunkName: "IconWorldOutlined" */
    /* webpackMode: "lazy" */
    '../World/WorldOutlined')),
    ZipFilled: dynamic(() => import(
    /* webpackChunkName: "IconZipFilled" */
    /* webpackMode: "lazy" */
    '../Zip/ZipFilled')),
    ZipOutlined: dynamic(() => import(
    /* webpackChunkName: "IconZipOutlined" */
    /* webpackMode: "lazy" */
    '../Zip/ZipOutlined')),
    ZoomInFilled: dynamic(() => import(
    /* webpackChunkName: "IconZoomInFilled" */
    /* webpackMode: "lazy" */
    '../ZoomIn/ZoomInFilled')),
    ZoomInOutlined: dynamic(() => import(
    /* webpackChunkName: "IconZoomInOutlined" */
    /* webpackMode: "lazy" */
    '../ZoomIn/ZoomInOutlined')),
    ZoomOutFilled: dynamic(() => import(
    /* webpackChunkName: "IconZoomOutFilled" */
    /* webpackMode: "lazy" */
    '../ZoomOut/ZoomOutFilled')),
    ZoomOutOutlined: dynamic(() => import(
    /* webpackChunkName: "IconZoomOutOutlined" */
    /* webpackMode: "lazy" */
    '../ZoomOut/ZoomOutOutlined')),
    Analytics: dynamic(() => import(
    /* webpackChunkName: "IconAnalytics" */
    /* webpackMode: "lazy" */
    '../Analytics/Analytics')),
    ChatSquared: dynamic(() => import(
    /* webpackChunkName: "IconChatSquared" */
    /* webpackMode: "lazy" */
    '../Chat/ChatSquared')),
    Dashboard: dynamic(() => import(
    /* webpackChunkName: "IconDashboard" */
    /* webpackMode: "lazy" */
    '../Dashboard/Dashboard')),
    Eshop: dynamic(() => import(
    /* webpackChunkName: "IconEshop" */
    /* webpackMode: "lazy" */
    '../Eshop/Eshop')),
    ExpandLess: dynamic(() => import(
    /* webpackChunkName: "IconExpandLess" */
    /* webpackMode: "lazy" */
    '../Expand/ExpandLess')),
    ExpandMore: dynamic(() => import(
    /* webpackChunkName: "IconExpandMore" */
    /* webpackMode: "lazy" */
    '../Expand/ExpandMore')),
    Finance: dynamic(() => import(
    /* webpackChunkName: "IconFinance" */
    /* webpackMode: "lazy" */
    '../Finance/Finance')),
    Fulfilment: dynamic(() => import(
    /* webpackChunkName: "IconFulfilment" */
    /* webpackMode: "lazy" */
    '../Fulfilment/Fulfilment')),
    Inventory: dynamic(() => import(
    /* webpackChunkName: "IconInventory" */
    /* webpackMode: "lazy" */
    '../Inventory/Inventory')),
    Marketing: dynamic(() => import(
    /* webpackChunkName: "IconMarketing" */
    /* webpackMode: "lazy" */
    '../Marketing/Marketing')),
    Orders: dynamic(() => import(
    /* webpackChunkName: "IconOrders" */
    /* webpackMode: "lazy" */
    '../Orders/Orders')),
    Boost: dynamic(() => import(
    /* webpackChunkName: "IconBoost" */
    /* webpackMode: "lazy" */
    '../Boost/Boost')),
    Ebook: dynamic(() => import(
    /* webpackChunkName: "IconEbook" */
    /* webpackMode: "lazy" */
    '../Ebook/Ebook')),
};
export const RakutenIcon = (_a) => {
    var { icon, width = 16 } = _a, otherProps = __rest(_a, ["icon", "width"]);
    if (icon) {
        const Icon = IconDynamicImports[icon];
        if (Icon) {
            return React.createElement(Icon, Object.assign({ style: { width }, "data-qa": "rakuten-icon" }, otherProps));
        }
    }
    return null;
};
